export const searchFieldPlaceholderText = 'Search Gumtree';
export const searchFieldAriaLabel = 'Type search query';
export const locationFieldAriaLabel = 'Location';
export const locationFieldPlaceholderText = 'Add postcode or location';
